module.exports = __webpack_public_path__ + "assets/icons/arrived-emoji.gif";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/arrived-emoji.gif
// module id = ./src/styles/icons/emojies/arrived-emoji.gif
// module chunks = 0